import React from "react";
import { IKImage, IKContext } from "imagekitio-react";
import Typewriter from "typewriter-effect";
import "./Home.css";
import dot from "../../assets/dot.png";
import dot1 from "../../assets/dot1.png";
import dot2 from "../../assets/dot2.png";
import CountUp from "react-countup";
import box from "../../assets/box-cut.svg";
import flag from "../../assets/flag.svg";

const Home = () => {
  return (
    <div className="out">
      <div className="section-home">
        <div className="home-content">
          <div className="section__deco deco__left"></div>

          <p className="hi-there">
            HEY THERE!<span className="myname"> MY NAME IS</span>
          </p>
          <h1 className="name">
            PRAVIN <span>KANTH</span>
          </h1>
          <div className="check">
            {/* <span>I am</span> */}
          <Typewriter
            onInit={(typewriter) => {
              typewriter
                .typeString("Code, AI, Markets...")
                .start(); 
            }}
            options={{
              cursor: "",
              delay: 75,

            }}
          />
          </div>

          <div className="move">
            <p className="about-me">
              Software Engineer at HPE, building scalable systems.
              <br></br>Committed to crafting exceptional web experiences by{" "}
              <br></br>merging creativity and technical expertise.
            </p>
            <ul className="profiles">
              <li>
                <a
                  target="_blank"
                  href="https://www.linkedin.com/in/pravin-kanth/"
                  className="social-link linkedin"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    viewBox="0 0 448 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z"></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://github.com/PravinKanth"
                  className="social-link github"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    viewBox="0 0 496 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M165.9 397.4c0 2-2.3 3.6-5.2 3.6-3.3.3-5.6-1.3-5.6-3.6 0-2 2.3-3.6 5.2-3.6 3-.3 5.6 1.3 5.6 3.6zm-31.1-4.5c-.7 2 1.3 4.3 4.3 4.9 2.6 1 5.6 0 6.2-2s-1.3-4.3-4.3-5.2c-2.6-.7-5.5.3-6.2 2.3zm44.2-1.7c-2.9.7-4.9 2.6-4.6 4.9.3 2 2.9 3.3 5.9 2.6 2.9-.7 4.9-2.6 4.6-4.6-.3-1.9-3-3.2-5.9-2.9zM244.8 8C106.1 8 0 113.3 0 252c0 110.9 69.8 205.8 169.5 239.2 12.8 2.3 17.3-5.6 17.3-12.1 0-6.2-.3-40.4-.3-61.4 0 0-70 15-84.7-29.8 0 0-11.4-29.1-27.8-36.6 0 0-22.9-15.7 1.6-15.4 0 0 24.9 2 38.6 25.8 21.9 38.6 58.6 27.5 72.9 20.9 2.3-16 8.8-27.1 16-33.7-55.9-6.2-112.3-14.3-112.3-110.5 0-27.5 7.6-41.3 23.6-58.9-2.6-6.5-11.1-33.3 2.6-67.9 20.9-6.5 69 27 69 27 20-5.6 41.5-8.5 62.8-8.5s42.8 2.9 62.8 8.5c0 0 48.1-33.6 69-27 13.7 34.7 5.2 61.4 2.6 67.9 16 17.7 25.8 31.5 25.8 58.9 0 96.5-58.9 104.2-114.8 110.5 9.2 7.9 17 22.9 17 46.4 0 33.7-.3 75.4-.3 83.6 0 6.5 4.6 14.4 17.3 12.1C428.2 457.8 496 362.9 496 252 496 113.3 383.5 8 244.8 8zM97.2 352.9c-1.3 1-1 3.3.7 5.2 1.6 1.6 3.9 2.3 5.2 1 1.3-1 1-3.3-.7-5.2-1.6-1.6-3.9-2.3-5.2-1zm-10.8-8.1c-.7 1.3.3 2.9 2.3 3.9 1.6 1 3.6.7 4.3-.7.7-1.3-.3-2.9-2.3-3.9-2-.6-3.6-.3-4.3.7zm32.4 35.6c-1.6 1.3-1 4.3 1.3 6.2 2.3 2.3 5.2 2.6 6.5 1 1.3-1.3.7-4.3-1.3-6.2-2.2-2.3-5.2-2.6-6.5-1zm-11.4-14.7c-1.6 1-1.6 3.6 0 5.9 1.6 2.3 4.3 3.3 5.6 2.3 1.6-1.3 1.6-3.9 0-6.2-1.4-2.3-4-3.3-5.6-2z"></path>
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://twitter.com/i_PravinKanth"
                  className="social-link twitter"
                >
                  <svg
                    stroke="currentColor"
                    svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="currentColor"
                    height="1em"
                    width="1em"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                  </svg>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  href="https://www.instagram.com/p._.kanth/"
                  className="social-link instagram"
                >
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    viewBox="0 0 448 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"></path>
                  </svg>
                </a>
              </li>
            </ul>
            <div className="home__btns">
              <a
                href="https://drive.google.com/file/d/1BNq0umfFG2WBcSZUVfn8A7zB-7S18tsP/view?usp=sharing"
                target="_blank"
                rel="noreferrer"
                className="btn text-cs explore"
              >
                <span className="btntxt">View My Work</span>
              </a>
              <a href="#pursuits" className="hero__link text-cs">
                My Skills
              </a>
            </div>
          </div>
        </div>

        <div className="just">
          <div className="home-image">
            <div className="wrapp">
              <p className="home__data home__data-one">
                <span className="text-lg">
                  <CountUp start={0} end={5} duration={3.5} /> <b>+</b>
                </span>
                <span className="text-sm text-cs">
                  Engineering <span>Internships</span>
                </span>
              </p>
              <p className="home__data home__data-two">
                <span className="text-lg">
                  <CountUp start={0} end={8} duration={3.5} /> <b>+</b>
                </span>
                <span className="text-sm text-cs">
                  Completed <span>Projects</span>
                </span>
              </p>
              <p className="home__data home__data-three">
                <span className="text-lg">
                  <CountUp start={0} end={4} duration={3.5} /> <b>+</b>
                </span>
                <span className="text-sm text-cs">
                  Freelance <span>Experience</span>
                </span>
              </p>

              <div className="banner">
                {/* <img className="img-dp" src={temp} alt="pravin kanth" /> */}
                {/* <img className="img-dp" src={p2} alt="pravin kanth" /> */}

                <IKContext urlEndpoint="https://ik.imagekit.io/jtnilec50">
                  <IKImage
                    className="img-dp"
                    path="/Portfolio/i_PravinKanth.jpeg"
                  />
                </IKContext>

                <img className="shape img-dot1" src={dot1} alt="dot" />
                <img className="shape img-dot2" src={dot} alt="dot" />
                <img className="shape img-dot3" src={dot2} alt="dot" />
                <img
                  className="jj"
                  decoding="async"
                  data-aos="fade-up"
                  data-aos-offset="50"
                  src={box}
                  alt="Crossed out box illustration"
                  data-rellax-speed="-1"
                ></img>
              </div>
            </div>
          </div>
        </div>

        <img
          decoding="async"
          data-aos="fade-up"
          data-aos-offset="50"
          src={flag}
          alt="Hreat flagpole illustration"
          className="flag-icon"
          data-rellax-speed="1"
        ></img>
        <a
          href="#skills-left"
          className="r90 left hide-el bl has-rotate hide-m"
          data-cursor="false"
          data-cursor-type="link"
        >
          <span className="left">&larr;</span>
          <span className="text"> &nbsp;About me</span>
        </a>
      </div>
    </div>
  );
};

export default Home;
